export default __webpack_public_path__ + "static/media/car-service.20972424.svg";